import { transform } from 'ol/proj'

const location = null;

export default function watchCurrentLocation(onNewLocation) {
  let lastError = null;

  const watchSuccess = (position) => {
    //console.warn('****** .watchSuccess - START');

    //const accuracyInFt = position.coords.accuracy * 3.28084;
    const point4326 = [ position.coords.longitude, position.coords.latitude ];
    const point2264 = transform(point4326, 'EPSG:4326', 'EPSG:2264');

    //let latestGpsPosition = position;

    let record = {
      latitude:  position.coords.latitude,
      longitude: position.coords.longitude,
      accuracy:  position.coords.accuracy,
      timestamp: position.timestamp,
      x:  point2264[0],
      y:  point2264[1],
      accuracyInFt:  position.coords.accuracy * 3.28084,
    }
    onNewLocation(record);
  };

  const locationError = (error) => {
    //console.warn('*** updateCurrentLocation-locationError - START');
    //alert('Location Error: ' + error.code, error.message);
    // error getting location
    lastError = error;
    //console.log(lastError);
  };

  const options = {
    enableHighAccuracy: true,
    maximumAge:     0,
    timeout:    16000
  };

  //console.warn('starting location watch **********************');

  // start watch for new position
  const id = navigator.geolocation.watchPosition(
      watchSuccess,
      locationError,
      options
  );
  return id;
}

export { location };
